import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { id: String }

  connect() {
    // Ensure waiter animation is stopped on initial render
    // this.stopWaiter();
    console.log(`SyncController connected for sync ${this.idValue}`);

  }

  submit() {
      // console.log(`Submitting sync form `);
      const sourceDefaultEl = document.querySelector(`#source-${this.idValue} .default`);
      const sourceProgressEl = document.querySelector(`#source-${this.idValue} .sync-progress`);


      if (sourceDefaultEl) {
        sourceDefaultEl.classList.add('d-none');
      }

      if (sourceProgressEl) {
        console.log('Showing source progress element');
        sourceProgressEl.classList.remove('d-none');
      } else {
        console.warn('Source progress element not found');
      }

      this.formTarget.requestSubmit()

  }

  stopWaiter() {
    // Exposed so views can rely on controller instead of inline script
    if (!this.idValue) return;
    console.log(`Stopping waiter animation for sync ${this.idValue}`);
    const svg = document.getElementById(`waiter-${this.idValue}`);
    if (svg && typeof svg.pauseAnimations === 'function') {
      try { svg.pauseAnimations(); } catch(e) { console.warn('Could not pause waiter animation', e); }
    }
    const circle = svg ? svg.querySelector('circle.waiter-circle') : null;
    if (circle) circle.style.opacity = '0';
  }


  activateSubmit(event) {
    console.log("Activating submit button based on selection");
    const select = event.target;
    const submitButton = this.formTarget.querySelector('input[type="submit"]');
    if (select.value) {
      submitButton.disabled = false;
      submitButton.classList.add('btn-primary');
      submitButton.classList.remove('btn-outline-secondary');
    } else {
      submitButton.disabled = true;
      submitButton.classList.add('btn-outline-secondary');
      submitButton.classList.remove('btn-primary');
    }
  }

}